import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from "react";
import MoreVert from "@mui/icons-material/MoreVert";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableFooter from "@mui/material/TableFooter";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import red from "@mui/material/colors/red";
import DataTableRow from "./DataTableRow";
/**
 * @deprecated use material-react-table
 * @param param0
 * @returns
 */
export function DataTable({ footer, columns, rows, visibleFields = [], sx, }) {
    const [selectedFields, setSelectedFields] = useState(visibleFields);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const changeSelectedFields = (field) => {
        const prevSelectedFields = [...selectedFields];
        if (selectedFields.includes(field)) {
            prevSelectedFields.splice(selectedFields.indexOf(field), 1);
        }
        else {
            prevSelectedFields.push(field);
        }
        setSelectedFields(prevSelectedFields);
    };
    return (_jsxs(Table, { className: "DataTable", sx: Object.assign({ width: "100%" }, sx), stickyHeader: true, size: "small", children: [_jsx(TableHead, { children: _jsx(TableRow, { children: columns
                        .filter((column) => !selectedFields ? true : selectedFields.includes(column.field))
                        .map((column) => (_jsxs(TableCell, { sx: {
                            textAlign: column.type === "number" ? "right" : undefined,
                            fontWeight: "bold",
                            backgroundColor: red,
                        }, children: [column.headerName, column.field === "details" && (_jsxs(Fragment, { children: [_jsx(IconButton, { sx: { float: "right" }, size: "small", "aria-controls": open ? "generic-columns-menu" : undefined, "aria-haspopup": "true", "aria-expanded": open ? "true" : undefined, onClick: handleClick, children: _jsx(MoreVert, {}) }), _jsx(Menu, { id: "generic-columns-menu", anchorEl: anchorEl, open: open, onClose: handleClose, slotProps: {
                                            list: {
                                                "aria-labelledby": "basic-button",
                                            },
                                        }, children: columns
                                            .filter((column) => column.field !== "details")
                                            .map((column) => (_jsx(MenuItem, { children: _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: selectedFields.includes(column.field), onClick: () => changeSelectedFields(column.field) }), label: column.headerName }) }, column.field))) })] }))] }, column.field))) }) }), _jsx(TableBody, { children: rows.map((row) => (_jsx(DataTableRow, { row: row, columns: columns, visibleFields: selectedFields }, row.id))) }), footer && (_jsx(TableFooter, { children: _jsx(DataTableRow, { row: footer, columns: columns, visibleFields: selectedFields }, "footer") }))] }));
}
//# sourceMappingURL=DataTable.js.map